import React from "react";
import SalesDocumentHeader from "../../components/SalesDocument/SalesDocumentHeader";
import { useTranslation } from "react-i18next";
const OrderEditPage: React.FC<{ params?: { [key: string]: any } }> = ({ params }) => {
    const { documentNo = "",documentType = 1 } = params || {};
    const { t } = useTranslation();
    return (
        <SalesDocumentHeader
            key={ documentNo }
            documentNo={documentNo}
            documentType={documentType}
            readUrl={`/salesDocumentApi/GetDocument/?documentType=${documentType}&documentNo=${documentNo}&open=false`}
            updateUrl="taco"
            deleteUrl="taco"
            history={true}
            title={
                //== instead of === as sometimes they are cast as string, fucking JS XD
                documentType == 1 ? t("common.order")
                : documentType == 2
                    ? t("common.invoice")
                    : t("common.credit")}
        />
    );
};

export default OrderEditPage;
